/* c8 ignore start */
import { useEffect, useState } from "react";

export const useHandleClickVideo = (
  videoRef,
  wrapperRef,
  setIsFullScreen,
  props
) => {
  const { allowFullscreen, allowPlayPause } = props;
  const [clickTimer, setClickTimer] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (clickTimer) {
        setClickTimer(false);
      }
    }, 800);
    return () => clearTimeout(timer);
  }, [clickTimer]);
  const handleClick = () => {
    if (clickTimer) {
      handleDoubleClick();
      return;
    }
    setClickTimer(true);

    if (allowPlayPause && videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  };

  /* c8 ignore next 12 */
  const handleDoubleClick = () => {
    if (allowFullscreen) {
      if (document?.fullscreenElement) {
        document?.exitFullscreen();
        setIsFullScreen(false);
      } else {
        wrapperRef.current.requestFullscreen();
        setIsFullScreen(true);
      }
      videoRef.current.play();
    }
  };
  return { handleClick, handleDoubleClick };
};
/* c8 ignore stop */
